import { baseBuild } from '@/core/services/network/config/baseBuild';
import type { AppDispatch } from '@/app/store/store';
import { PosCartService } from '../application/services/PosCartService';
import { PosCartAdapter } from '../infra/adapters/posCart.adapter';
import { PdpAdapter } from '@/features/pdp/infra/adapters/pdp.adapter';
import { CustomizationAdapter } from '@/features/customization/infra/adapters/customization.adapter';

export function posCartBuild(dispatch: AppDispatch) {
  return baseBuild(
    (d: AppDispatch) => ({
      posCartRepo: new PosCartAdapter(d),
      pdpRepo: new PdpAdapter(d),
      customizationRepo: new CustomizationAdapter(d),
    }),
    (repos) => new PosCartService(
      repos.posCartRepo,
      repos.pdpRepo,
      repos.customizationRepo
    ),
    dispatch
  );
}
